import type { DetailsPanelContentCreatedDateQuery } from '../queries/__types__/DetailsPanelContentCreatedDateQuery';

export const normalizeContentCreatedData = (data?: DetailsPanelContentCreatedDateQuery) => ({
	date: data?.content?.nodes?.[0]?.metadata.createdDate,
});
